import {ValueObject} from '@s-ui/domain'

import {ConfigContext} from '../../config/context/index.js'

/**
* @param {Object} deps
* @param {string} deps.adId
* @param {string} deps.adTitle
* @param {string} deps.bodyTypeIdWithDoors
* @param {string} deps.carPlate
* @param {string} deps.colourId
* @param {string} deps.comments
* @param {string} deps.email
* @param {string} deps.environmentalLabel
* @param {number} deps.fuelId
* @param {Boolean}deps.hidePhone
* @param {string} deps.images
* @param {number} deps.makeId
* @param {string} deps.mileage
* @param {string} deps.modelId
* @param {string} deps.phone
* @param {string} deps.plateRegistrationDate
* @param {string} deps.price
* @param {number} deps.provinceId
* @param {string} deps.publishInVibbo
* @param {string} deps.transmissionTypeId
* @param {string} deps.userId
* @param {string} deps.versionId
* @param {string} deps.year
* @param {string} deps.zipCode
} */
export class RequestDraftValueObject extends ValueObject {
  getAdId() {
    return this._adId
  }

  getUserId() {
    return this._userId
  }

  toAdRequestBody({categoryId}) {
    const {USER_AD_CATEGORIES} = ConfigContext.get('seller')
    const adRequestBodyByCategory = {
      [USER_AD_CATEGORIES.CLASSIC_BIKE]: () => this.#getClassicBikeAdRequestBody(),
      [USER_AD_CATEGORIES.MINIBIKE]: () => this.#getMinibikeAdRequestBody()
    }
    const getAdRequestBody = adRequestBodyByCategory[categoryId]

    return getAdRequestBody ? getAdRequestBody() : this.toJSON()
  }

  #getClassicBikeAdRequestBody() {
    return {
      comments: this._comments || null,
      hidePhone: this._hidePhone,
      images: this._images,
      phone: this._phone,
      price: this._price,
      title: this._adTitle,
      zipCode: this._zipCode
    }
  }

  #getMinibikeAdRequestBody() {
    return {
      comments: this._comments || null,
      hidePhone: this._hidePhone,
      images: this._images,
      phone: this._phone,
      price: this._price,
      title: this._adTitle,
      zipCode: this._zipCode
    }
  }
}
